import { dailySessionNotes } from '../../actions/constant';

const {
  UPDATE_DAILY_SESSION_NOTES_SUCCESS,
  UPDATE_DAILY_SESSION_NOTES_FAILURE,
  RESET_UPDATE_DAILY_SESSION_NOTES,
} = dailySessionNotes;

const intitialstate: object = {
  response: null,
  isError: false,
  errorMessage: '',
};

export const updateDailySessionNotes = (state = intitialstate, action: any) => {
  switch (action.type) {
    case UPDATE_DAILY_SESSION_NOTES_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload,
        errorMessage: '',
      };
    }

    case UPDATE_DAILY_SESSION_NOTES_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
      };
    case RESET_UPDATE_DAILY_SESSION_NOTES:
      return intitialstate;

    default:
      return state;
  }
};
